<template>
    <div>
        <div>
            <img src="../assets/about.jpg" style="width: 100%;">
        </div>
        <div class="center gray fs18" style="padding-top: 40px;">
            <p class="black fs32 fw500">{{ $t('company') }}</p>
            <span class="backyel dib divide"></span>
            <div class="left" :class="$style.desc">
                <p class="mb30">{{ $t('about1') }}</p>
                <p class="mb30">{{ $t('about2') }}</p>
                <p class="mb30">{{ $t('about3') }}</p>
				<p class="mb30">{{ $t('about7') }}</p>
				<p class="mb30">{{ $t('about8') }}</p>
				<p class="mb30">{{ $t('about9') }}</p>
            </div>
        </div>
        <div class="center fs18 backgray" style="padding-top: 30px;">
            <p class="black fs32 fw500">{{ $t('loca') }}</p>
            <span class="backyel dib divide"></span>
            <div :class="$style.desc1">
                <p style="padding-bottom: 40px;">{{ $t('about4') }}</p>
            </div>
        </div>
        <div class="dflex fw fw500 acsb" :class="$style.loc">
            <div v-for="item in companies" :key="item.name" :class="$style.loc1">
                <div>
                    <!-- <el-amap :zoom="zoom" :center="item.center">
                        <el-amap-marker :position="item.center"></el-amap-marker>
                    </el-amap> -->
                    <img :src="imgSrc(item)" alt="" :class="$style.pic">
                </div>
                <p class="yel fw500 fs20" style="padding: 17px 0px;">{{ item.name.toUpperCase() }}{{item.isMain? ($i18n.locale === 'en' ? ' (':'')+$t('maino')+($i18n.locale === 'en'?')':'') : $t('sideo')}}</p>
                <div class="dflex">
                    <i class="el-icon-location" style="padding-top: 3px;"></i>
                    <p class="pdl10" style="font-size: 15px;">{{ item.addr.toUpperCase() }}{{$i18n.locale === 'en' ? ', ': ''}}{{item.addr1.toUpperCase()}}</p>
                </div>
                <!-- <p class="pdl10">{{ item.addr1 }}</p> -->
                <p class="pt10" v-for="person in item.persons" :key="person.name">
                <i class="el-icon-phone"></i>
                <template>
                    <span class="pdl10 dib" style="width: 18%;">{{person.name}}</span><span class="pdl10 dib" style="width: 35%;">({{person.role}})</span><span class="pdl10">{{person.mobilePrefix}} {{ person.mobile }}</span>
                </template>
                </p>
                <p class="pt10 mb30 dflex">
                    <i class="el-icon-message" style="padding-top: 3px;"></i>
                    <!-- <img src="../assets/email1.svg" width="14"> -->
                    <span class="pdl10">
                        {{ item.persons[0].email }}
                    </span>
                </p>
            </div>
            <div :class="$style.w4" class="center">
                <img :src="fburl" alt="" :class="$style.w4" class="cp mb30 mt60 biggerpic biggerpics" @click="goFB">
                <img :src="waurl" alt="" :class="$style.w4" class="cp biggerpic biggerpics" @click="goWhatsappAbout">
                <p class="gray dflex" style="margin-top:20px;">
                    <span class="right" :class="$style.right">{{ $t('pr2') }}</span>
                    <span class="f1">11:00 am - 5:30 pm</span>
                </p>
                <p class="gray dflex">
                    <span class="right" :class="$style.right">{{ $t('pr3') }}</span>
                    <span class="f1">10:30 am - 2:00 pm</span>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import {companies} from '../data.js';
// import {load, Map, Marker} from 'vue-google-maps';
// import VueGoogleMap from 'vue-google-maps';
// VueGoogleMap.load({
//     'key': 'YOUR_API_KEY',
// });

import waen from '../assets/whatsapp_en.jpg';
import wazh from '../assets/wahtsapp_cn.jpg';
import fben from '../assets/fben.png';
import fbzh from '../assets/fbzh.png';

export default {
    name: 'About',
    data() {
        return {
            waurl: this.$i18n.locale === 'en' ? waen : wazh,
            fburl: this.$i18n.locale === 'en' ? fben : fbzh,
            companies,
            zoom: 12,
            // center: [121.59996, 31.197646],
        }
    },
    created() {
        this.$top();
    },
    methods: {
        imgSrc(item) {
            return require('../assets/'+item.url);
        }
    }
}
</script>
<style module>
.desc {
    margin: 20px 300px 80px 300px;
}
.desc1 {
    margin: 20px 200px;
}
.loc {
    margin: 50px 200px;
}
.loc1 {
    width: 400px;
}
.pic {
    width: 400px;
}
.w4 {
    width: 300px;
}
.right {
    padding-right:30px;
    width:160px;
}
@media screen and (max-width: 770px) {
    .desc,.desc1 {
        margin: 20px;
    }
    .loc {
        margin: 30px;
    }
    .loc1 {
        width: 100%;
    }
    .pic {
        width: 100%;
    }
    .w4 {
        width: 90%;
    }
    .right {
        width:39%;
        padding-right: 10px;
    }
}
</style>
